import { withInstall } from '../../../utils/with-install'
import HeatMapLayer from './HeatMapLayer.vue'

export const ElAmapLocaHeatmap = withInstall(HeatMapLayer)
export default ElAmapLocaHeatmap
